<ng-container *ngIf="isM365AuthType">
    <sk-feedback class="{{this.styles}}" *ngIf="areAllUsersMatched === false" [dismissible]="false" icon="warning"
        [subject]="'settings.O365.UNMATCHED_FEEDBACK.SUBJECT' | translate" type="danger">
        <span translate="settings.O365.UNMATCHED_FEEDBACK.TEXT"></span>
        <button [disabled]="!isCurrentUserAdmin()" sk-button translate="settings.O365.UNMATCHED_FEEDBACK.BUTTON"
            class="ml-100" (click)="openUsersMatchingWizard()"></button>
    </sk-feedback>
</ng-container>
